module.exports = __webpack_public_path__ + "static/directoryTeams@2x-9468480de9116cd313dd5a7c1d0aa03d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/collaboration/directoryTeams@2x.jpg
// module id = 2578
// module chunks = 168707334958949